import { CountUp } from 'countup.js';

export default class AscendingNumber {
    constructor() {
        console.log('%c👍🏼 Ascending Number', 'color: yellow');
        this.ascendingNumbers = document.querySelectorAll('.ascending-number')
    }
    init() {
        this.ascendingNumbers.forEach((elem, i) => {

            let options = { 
                enableScrollSpy: true,
                prefix:  elem.dataset.countupPrefix,
                suffix: elem.dataset.countupSuffix,
            }
            
            new CountUp(elem, elem.dataset.countupValue, options);
        })
    }
}